
import React from 'react';
import styled from 'styled-components';
import { isDesktop, isTab } from '../utils/globalConfig';
import { Button } from "@vds/buttons";
import { Line } from '@vds/lines';

const PrimaryButton = styled(Button)`
position: ${props => props.pt? "sticky" : "" };
float:${isDesktop ? 'right' : 'none'};
bottom:7px;
z-index:7;
margin-bottom:20px;
left:${isTab ? '20%' : ''};
`;

const StyledLine = styled(Line)`
margin-bottom: 10px;
`

const Footer = ({ ctaLabel, disabled, handleButtonChange, btnType,ariaLabel, btn}) => {

    const handleButtonClick = () => {
        handleButtonChange();
    }

    return (
        <>
            <StyledLine type="secondary" />
            <PrimaryButton
                aria-label={ariaLabel}
                size="large"
                data-testid="footerButton"
                width={isDesktop ? '30%' : isTab ? '50%' : '100%'}
                disabled={disabled}
                use={btnType ? btnType : "primary"}
                pt = {btn}
                onClick={() => handleButtonClick()}
            >{ctaLabel}
            </PrimaryButton>
        </>

    )
}

export default Footer;